export default function Footer (){
    return(
        <>
            <div className="bg-[#5b90ab70] w-full rounded-2xl">
            <div className="flex flex-col md:flex-row justify-between">
                <div className="p-8 flex flex-col gap-2">
                    <h2 className="text-white text-xl"><span className="font-semibold">Sede Legale : </span>Via Leonardo da Vinci, 23824 Dervio LC</h2>
                    <h2 className="text-white text-xl"><span className="font-semibold">Partita Iva : </span>04109870131</h2>
                    <h2 className="text-white text-xl"><span className="font-semibold">Cod Univoco : </span>W7YVJK9</h2>
                    <h2 className="text-white text-xl"><span className="font-semibold">Codice Fiscale : </span>LNBNDN93A13A745N</h2>
                    <h2 className="text-white text-xl"><span className="font-semibold">Pec : </span>larioclima@pec.it</h2>
                </div>
                <div className="p-8 flex flex-col gap-2 text-left lg:text-right">
                    <h2 className="text-white text-xl"><span className="font-semibold">Mail : </span>nordin93@hotmail.it</h2>
                    <h2 className="text-white text-xl"><span className="font-semibold">Telefono : </span>320 318 4317</h2>
                    <h2 className="text-white text-xl"><span className="font-semibold">Nome Azienda : </span>Lario Clima Service di Nordin El Anboubi</h2>
                    <h2 className="text-white text-xl"><span className="font-semibold underline">Il seguente sito non usa nessun Cookie</span></h2>
                </div>
            </div>

            {/* Copyright + powered by */}
            <div className="border-t border-white/30 px-8 py-4 text-sm text-white flex flex-col md:flex-row justify-between items-center">
                <p>&copy; {new Date().getFullYear()} Tutti i diritti riservati.</p>
                <a
                href="https://curriculum-mattia-donizetti.netlify.app"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-gray-200 mt-2 md:mt-0"
                >
                Powered by Mattia Donizetti
                </a>
            </div>
            </div>

        </>
    )
}